import React, { FC } from 'react';

import { addWithConfig } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { Box } from 'components/ui';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

export interface IItemActionsProps {
  showEdit?: boolean;
  onEdit: () => void;
  onRemove: () => void;
}

const styles = StyleSheet.create({
  layout: {
    alignItems: 'center',
    flexDirection: 'row',
  },
});

const Layout = ({ children, ...props }: React.ComponentProps<typeof Box>) => (
  <Box {...props} style={styles.layout}>
    {children}
  </Box>
);

const StyledActionButton = addWithConfig(ActionButton).withConfig({
  _text: {
    color: primitive.$fieryRed,
    fontSize: 'sm',
  },
  style: {
    marginRight: 16,
  },
});

const ItemActions: FC<React.PropsWithChildren<IItemActionsProps>> = ({
  showEdit = true,
  onEdit,
  onRemove,
}) => {
  return (
    <Layout testID="item-actions">
      {showEdit && (
        <StyledActionButton
          aria-label={t('edit')}
          testID="edit-item-action"
          color="primary"
          variant={ActionButtonVariants.TEXT_ONLY}
          size={ActionButtonSizes.SMALL}
          onPress={onEdit}
        >
          {t('edit')}
        </StyledActionButton>
      )}
      <StyledActionButton
        aria-label={t('remove')}
        testID="remove-item-action"
        color="primary"
        variant={ActionButtonVariants.TEXT_ONLY}
        size={ActionButtonSizes.SMALL}
        onPress={onRemove}
      >
        {t('remove')}
      </StyledActionButton>
    </Layout>
  );
};

export default ItemActions;
